import React, { useState } from "react";

import PageTitle from "../../Components/PageTitle";
import ColorPicker from "../../Components/ColorPicker";
import Header from "../../Components/Header";
import Card from "../../Components/Card";
import * as S from "./style";
export default function Resume() {
  const [state, setState] = useState("experience");
  const [active, setActive] = useState("experience");
  return (
    <S.Wrapper style={{ minHeight: "100vh" }}>
      <ColorPicker />
      <S.Container>
        <S.Row>
          <PageTitle spanhead="My" spantext="My">
            Resume
          </PageTitle>
        </S.Row>
        <S.TableTitle>
          <S.Tablelabel onClick={() => setState("experience")}>
            <S.TableItem
              onClick={() => setActive("experience")}
              className={`${active === "experience" ? "active" : ""}`}
            >
              experience
            </S.TableItem>
          </S.Tablelabel>
          <S.Tablelabel onClick={() => setState("education")}>
            <S.TableItem
              onClick={() => setActive("education")}
              className={`${active === "education" ? "active" : ""}`}
            >
              education
            </S.TableItem>
          </S.Tablelabel>
        </S.TableTitle>
        <S.ExperienceContent displayed={state} className="fade">
          <Card
            dateparagraph="Sep 2020 - Present"
            titleCard="Front-End Developer"
            subtitlecard="The Sailors, Saudi Arabia"
            descriptioncard="Led the design and development of multiple enterprise-level microservice applications using the latest technologies of ReactJS and TypeScript,led the development of several products E2E, from identifying system requirements and partner dependencies to workload balancing, software implementation, engineering, testing, and configuring metrics, alarms, monitors, and dashboards
            ,and continuous Integration, Deployment Pipeline Integration, pull requests, code reviews, load, stress testing, E2E testing
            "
          />
          <Card
            dateparagraph="Nov 2021 - Jan 2022"
            titleCard="Front-End Developer (StartUp)"
            subtitlecard="Triple Q, Palestine Metropolitan Area"
            descriptioncard="Creating sites and landing pages using WordPress and Shopify for StartUp clients,and supervise the developers and help them create a roadmap for all the steps to get the perfect result"
          />
          <Card
            dateparagraph="Jan 2021 - Dec 2021"
            titleCard="Front-End Developer "
            subtitlecard="Mars Technology, UAE"
            descriptioncard="
            Converted Figma and Adobe XD designs into codes using ReactJS that produced great web pages,
            designed and implemented enterprise applications of UAE platforms (Beljwar -  to find spaces to work and innovate) using JavaScript, jQuery, Metronic template, and AOS animation
            ,and build a lot of dashboards to control all data on sites or data on applications using React-Bootstrap and Material UI
            
            "
          />
          <Card
            dateparagraph="Jan 2021 - Dec 2021"
            titleCard="Front-End Developer "
            subtitlecard="Upwork, Freelance"
            descriptioncard="Designed and implemented enterprise applications of Saudi Arabia platforms (Tatweer -  Development site for contracting and construction works) using JavaScript, jQuery, Bootstrap, and AOS animation"
          />
          <Card
            dateparagraph="Apr 2020 - Sep 2020"
            titleCard="Front-End Developer ( Internship )"
            subtitlecard="Gaza Sky Geeks( Mercy Corps ), Global team of humanitarians"
            descriptioncard="Belonging to a very cool interactive community,
            full incubation period for life skills training
            , enhancing communication skills
            ,the opportunity to work on self-employment platforms remotely
            ,and practice how to deal with potential clients
            "
          />
        </S.ExperienceContent>
        <S.EducationContent displayed={state} className="fade">
          <Card
            dateparagraph="Aug 2014 - Sep 2019"
            titleCard="Bachelor of Civil Engineering"
            subtitlecard="Islamic University of Gaza, Palestine Metropolitan Area"
          />
          <Card
            dateparagraph="Aug 2019 - May 2020"
            titleCard="Front-End Development"
            subtitlecard="frontendmasters.com, Professional learning Path, Online"
          />
        </S.EducationContent>
      </S.Container>
      <Header />
    </S.Wrapper>
  );
}
